import { toast } from 'react-toastify';

type NotificationTypes = 'success' | 'error' | 'info';

const showNotification = (type: NotificationTypes, messageText: string) => {
  toast[type](messageText, {
    position: 'top-right',
    autoClose: 6000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
  });
};

export default showNotification;
